// @flow
import type {ApplicationStoreType} from 'constants/flow/flowTypes';
import {GENDER_KEYS_LIST} from 'constants/gender';

import type {GenderDataType} from 'reducers/gender/genderType';

/**
 * Get current gender data
 * @param {ApplicationStoreType} store - Application store
 * @return {GenderDataType} Gender data
 */
export const getCurrentGender = (store: ApplicationStoreType): GenderDataType => ({
    genderId: store.gender.currentGender,
    genderKey: GENDER_KEYS_LIST[store.gender.currentGender],
});
